import { Input } from "@bleu.builders/ui";
import React, { useEffect, useState } from "react";

const CPF_MASK = "999.999.999-99";
const CNPJ_MASK = "99.999.999/9999-99";

const stripNonDigits = (value) => value.replace(/\D/g, "");
const determineMask = (value) => (value.length > 11 ? CNPJ_MASK : CPF_MASK);
const applyMask = (value, mask) => {
  let maskedValue = "";
  let valueIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    if (mask[i] === "9") {
      if (value[valueIndex]) {
        maskedValue += value[valueIndex];
        valueIndex++;
      } else {
        break;
      }
    } else {
      maskedValue += mask[i];
    }
  }

  return maskedValue;
};

export const CpfCnpj = ({ onChange, value, ...props }) => {
  const [displayValue, setDisplayValue] = useState("");

  useEffect(() => {
    const rawValue = stripNonDigits(value || "");
    const mask = determineMask(rawValue);
    setDisplayValue(applyMask(rawValue, mask));
  }, [value]);

  const handleChange = (event) => {
    const rawValue = stripNonDigits(event.target.value);
    const mask = determineMask(rawValue);
    const maskedValue = applyMask(rawValue, mask);

    if (rawValue.length <= stripNonDigits(CNPJ_MASK).length) {
      setDisplayValue(maskedValue);
      event.target.value = rawValue;
      onChange(event);
    }
  };

  return <Input {...props} value={displayValue} onChange={handleChange} />;
};
